import React from 'react'
import clsx from 'clsx'

const StatementList = ({
  statements = [],
  totalStatements = 0,
  availableInstances = [],
  filters,
  onFiltersChange,
  onDelete,
  onRefresh,
  onSelect,
  selectedStatementId,
  isLoading,
  isError,
  error,
  deletingId,
}) => {
  const handleSearchChange = (event) => {
    onFiltersChange?.({ ...filters, search: event.target.value })
  }

  const handleClearFilters = () => {
    onFiltersChange?.({ search: '' })
  }

  const handleDelete = (statement) => {
    if (!statement?.id) {
      return
    }
    const confirmDelete = window.confirm(
      `Delete statement "${statement.statementName}" from ${statement.instanceName}?`,
    )
    if (confirmDelete) {
      onDelete?.(statement.id)
    }
  }

  const handleRowSelection = (statement) => {
    onSelect?.(statement)
  }

  const handleRowKeyDown = (event, statement) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleRowSelection(statement)
    }
  }

  return (
    <section className="statement-list">
      <div className="statement-list__meta">
        <p>
          Showing {statements.length} of {totalStatements} statements
        </p>
        <button type="button" className="secondary" onClick={onRefresh} disabled={isLoading}>
          {isLoading ? 'Refreshing…' : 'Refresh'}
        </button>
      </div>

      <div className="statement-list__filters">
        <div className="statement-list__filter statement-list__filter--search">
          <label htmlFor="statement-filter-search">Search</label>
          <input
            id="statement-filter-search"
            type="search"
            placeholder="Filter by name or EPL"
            value={filters.search ?? ''}
            onChange={handleSearchChange}
          />
        </div>

        {filters.search && (
          <button type="button" className="secondary" onClick={handleClearFilters}>
            Clear search
          </button>
        )}
      </div>

      {isError ? (
        <div className="statement-list__error" role="alert">
          <p>{error?.message ?? 'Unable to load statements.'}</p>
        </div>
      ) : null}

      {isLoading && !statements.length ? (
        <div className="statement-list__placeholder" role="status">
          Loading statements…
        </div>
      ) : null}

      {!isLoading && statements.length === 0 ? (
        <div className="statement-list__placeholder" role="status">
          No statements match your current filters.
        </div>
      ) : null}

      {statements.length ? (
        <div className="statement-list__table-wrapper">
          <table className="statement-list__table">
            <thead>
              <tr>
                <th scope="col">Statement</th>
                <th scope="col" style={{ width: '80px', textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {statements.map((statement) => (
                <tr
                  key={statement.id ?? statement.statementName}
                  data-selected={selectedStatementId === statement.id ? 'true' : 'false'}
                  onClick={() => handleRowSelection(statement)}
                  onKeyDown={(event) => handleRowKeyDown(event, statement)}
                  role="button"
                  tabIndex={0}
                  aria-pressed={selectedStatementId === statement.id ? 'true' : 'false'}
                >
                  <th scope="row">{statement.statementName}</th>
                  <td style={{ textAlign: 'center' }}>
                    <button
                      type="button"
                      className={clsx('link-button', {
                        danger: deletingId === statement.id,
                      })}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDelete(statement)
                      }}
                      disabled={deletingId === statement.id}
                    >
                      {deletingId === statement.id ? 'Deleting…' : 'Delete'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </section>
  )
}

export default StatementList
